module.exports = __webpack_public_path__ + "static/img/about047.8c4a9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about047.png
// module id = hUGf
// module chunks = 1